import { useSelector, useDispatch } from "react-redux";
import RedesignedModal from "../../common/RedesignedModal";
import { CPButton, CustomisedTertiaryButton, TextWrapper } from "../../../constants/common/StyledGlobalConstants";
import { getPendoId } from "../../../util/cfstPendoUtils";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";
import { setSelectedSlotDetails, setRescheduleAppointmentDetails } from "../../../store/actions/schedulingportal/technicianAppointment";
import PropTypes from "prop-types";

const { TABLET } = DEVICE_BREAKPOINTS;

function AppointmentTimeUnavailable({ isApptAlreadyTaken, setIsApptAlreadyTaken, decrementStep, setCurrentIndex }) {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  const { isReschedule } = useSelector((state) => state.TECHNICIANAPPOINTMENT);
  const dispatch = useDispatch();

  const goBackHandler = () => {
    if (isReschedule) {
      dispatch(setRescheduleAppointmentDetails({}));
      setCurrentIndex(0);
    }
    dispatch(setSelectedSlotDetails({}));
    setIsApptAlreadyTaken(false);
    decrementStep();
  };

  const closeHandler = () => {
    setIsApptAlreadyTaken(false);
  };

  return (
    <RedesignedModal
      opened={isApptAlreadyTaken}
      onClickClose={closeHandler}
      zIndex="1001"
      isScrollable={false}
      title="Appointment time unavailable"
      ModalAriaLabel="Appointment time unavailable modal"
      closeIconId={getPendoId("appt-time-unavailable-modal-close-icon-button")}
      button={
        <>
          <CustomisedTertiaryButton
            id={getPendoId("appt-time-unavailable-modal-close-button")}
            ariaLabel="Close"
            tabIndex="0"
            size="large"
            buttonWidth={windowSize.width < TABLET && "100%"}
            marginTop={"0"}
            onClick={closeHandler}
          >
            CLOSE
          </CustomisedTertiaryButton>
          <CPButton
            id={getPendoId("appt-time-unavailable-modal-select-a-new-time-button")}
            ariaLabel="Select a new time"
            tab-index="0"
            size="large"
            secondary={false}
            boxButton={true}
            buttonHeight="40px"
            buttonWidth={windowSize.width < TABLET && "100%"}
            onClick={goBackHandler}
          >
            SELECT A NEW TIME
          </CPButton>
        </>
      }
    >
      <TextWrapper fontStyle="normal" fontWeight="400" fontSize="14px" lineHeight="20px" marginBottom="0" marginTop="0">
        Your preferred time slot has just been booked by someone else. Select a different slot.
      </TextWrapper>
    </RedesignedModal>
  );
}

AppointmentTimeUnavailable.propTypes = {
  isApptAlreadyTaken: PropTypes.bool.isRequired,
  setIsApptAlreadyTaken: PropTypes.func.isRequired,
  decrementStep: PropTypes.func.isRequired,
  setCurrentIndex: PropTypes.func.isRequired,
};

export default AppointmentTimeUnavailable;